import React, { ReactElement } from 'react';

import { Link } from 'react-router-dom';
import s from './Embla.module.scss';

type PropType = {
  title: string;
  url: string;
  imageName: string;
  contentClass: string;
  isCenter: boolean;
};

function EmblaSlide(props: PropType): ReactElement {
  const { title, url, imageName, contentClass, isCenter } = props;

  return (
    <div className={s.slide}>
      <div className={contentClass}>
        <Link
          to={url}
          tabIndex={isCenter ? undefined : -1}
          aria-label="Zu den Berufdetails"
        >
          <img src={imageName} alt={title} />
          <div className={s.textContainer}>{title}</div>
        </Link>
      </div>
    </div>
  );
}

export default EmblaSlide;
